import { SkeletonLoader, Stack } from "@bookingcom/bui-react";
import * as React from "react";
export function SkeletonListMultiLine({ amount = 3 }) {
    const items = [];
    for (let i = 0; i < amount; i++) {
        items.push(React.createElement(SkeletonLoader, { key: i, variant: "two-lines", width: "80%" }));
    }
    return React.createElement(Stack, { gap: 6 }, items);
}
